import React from "react";
import styles from "./innerEncryption.module.scss";
//import chatencrypt from "../../styles/images/chatencrypt.svg";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../styles/images/centerGreen.json";
type InnerEncryptionProps = {
  fromComponent: string;
  icon:any
}
export default function InnerEncryption({ fromComponent, icon }: InnerEncryptionProps) {

  return (
    <>
      <div className={styles.homeEncryption}>
        <div className="homeEncryptionlist"><Lottie className="svgLoading" loop={true} animationData={groovyWalkAnimation} /></div>
        <p className={styles.unifiedLink}>{`${fromComponent} End-to-end encrypted` }</p>
        <img src={icon} alt="" />
      </div>
    </>
  );
};
